import { Component, Input, OnInit } from '@angular/core';
import { DialogService } from 'src/app/core/services/dialog/dialog.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { BusinessResponseDTO } from 'src/app/shared/models/dtos/register-form/business-response-dto/business-response-dto';
import { PointSummaryDTO } from 'src/app/shared/models/dtos/responses/point-summary/point-summary-dto';

@Component({
  selector: 'app-points-summary',
  templateUrl: './points-summary.component.html',
  styleUrls: ['./points-summary.component.scss'],
})

/**
 * Shows summary of user points
 */
export class PointsSummaryComponent implements OnInit {
  @Input() pointSummary?: PointSummaryDTO;
  @Input() business?: BusinessResponseDTO;
  language = '';

  labels = {
    totalPoints: 'total-points',
    pointsAddedMonth: 'points-added-month',
    pointsExpiringMonth: 'points-expiring-month',
    nextPointsExpiring: 'next-points-expiring',
    pointsExpired: 'points-expired-december',
    pointsExpiring: 'points-expiring-december',
    pointsRedeemedMonth: 'points-redeemed-month',
    generateReport: 'generate-report',
  };

  /**
   * @constructor
   */
  constructor(
    private readonly translationService: TranslationService,
    private readonly dialogService: DialogService
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    this.translationService.translateObject(this.labels);
    this.language = this.translationService.getActiveLang();
  }

  /**
   * Opens Create a report modal
   */
  openCreateReportModal() {
    this.dialogService.openCreateReportModal(this.pointSummary?.familyId!);
  }

  /**
   * Returns the current year
   * @return {any} the current year
   */
  getThisYear(): any {
    return new Date().getFullYear();
  }

  /**
   * Returns the point expiration date
   * @return {any} the point expiration date
   */
  getPointExpiringDate(): any {
    if (this.pointSummary?.nextPointsExpiringDate) {
      return this.pointSummary.nextPointsExpiringDate!.split(' ')[0];
    }
    return '';
  }
}
